import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./BannerSection.css";
import { ReactComponent as ArrowRight } from "../../assets/developementservices/arrow-right.svg";
import FiverrIcon from "../../assets/fiverr.svg";
import { AnimatedButton } from "../common/AnimatedButton";
import testImage from "../../assets/hr-mockup.png";
import { motion } from "framer-motion";

const isExternal = (url) => /^(http|https):\/\//.test(url);

const BannerSection = React.memo(
  ({
    badge = { platform: "fiverr", rating: "4.9", stars: 5 },
    heading = ["Shaping The", "Digital Future", "With Heart, Not Just Code."],
    subheading = "We're not just techies - We're storytellers, problem-solvers, and your partners in digital growth.",
    primaryBtn = { label: "Plan your project with us", link: "/contact" },
    secondaryBtn = { label: "View our work", link: "/ourwork" },
  }) => {
    const stars = useMemo(
      () => Array.from({ length: badge.stars }),
      [badge.stars]
    );

    return (
      <section
        className="banner"
        // style={{
        //   backgroundImage: `url(${testImage})`,
        //   backgroundSize: "cover",
        //   backgroundPosition: "center",
        //   backgroundRepeat: "no-repeat"
        // }}
      >
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="banner-rating-badge" aria-label="Rating badge">
            {badge.platform === "fiverr" && (
              <span className="banner-platform-svg">
                <img
                  src={FiverrIcon}
                  alt="Fiverr rating badge"
                  loading="lazy"
                />
              </span>
            )}
            <b>{badge.rating}</b>{" "}
            {stars.map((_, i) => (
              <span key={i} aria-hidden="true">
                ⭐
              </span>
            ))}
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h1 className="banner-heading">
            {heading[0]}{" "}
            <span className="banner-highlight-script">{heading[1]}</span>{" "}
            {heading[2]}
          </h1>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <p className="banner-subheading">{subheading}</p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="banner-buttons">
            {isExternal(primaryBtn.link) ? (
              <a
                href={primaryBtn.link}
                className="banner-btn banner-animated-btn"
                rel="noopener noreferrer"
                target="_blank"
                aria-label={primaryBtn.label}
              >
                <span className="banner-btn-text">{primaryBtn.label}</span>
                <span className="banner-btn-circle">
                  <ArrowRight className="banner-arrow-icon" />
                </span>
              </a>
            ) : (
              // <Link
              //   to={primaryBtn.link}
              //   className="banner-btn banner-animated-btn"
              //   aria-label={primaryBtn.label}
              // >
              //   <span className="banner-btn-text">{primaryBtn.label}</span>
              //   <span className="banner-btn-circle">
              //     <ArrowRight className="banner-arrow-icon" />
              //   </span>
              // </Link>
              <AnimatedButton
                link={primaryBtn?.link}
                label={primaryBtn?.label}
              />
            )}

            {isExternal(secondaryBtn.link) ? (
              <a
                href={secondaryBtn.link}
                className="banner-btn banner-secondary-btn"
                rel="noopener noreferrer"
                target="_blank"
                aria-label={secondaryBtn.label}
              >
                {secondaryBtn.label}
              </a>
            ) : (
              <Link
                to={secondaryBtn.link}
                className="banner-btn banner-secondary-btn"
                aria-label={secondaryBtn.label}
              >
                {secondaryBtn.label}
              </Link>
            )}
          </div>
        </motion.div>
      </section>
    );
  }
);

export default BannerSection;
